module.exports = __webpack_public_path__ + "static/media/cough.995bbf24.png";